export const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }, 'insertTemplate'],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['attachment'],
  ],
};

export const allowedFileTypes = {
  accept: '.pdf,.docx,.xlsx,.jpeg,.jpg,.heic,.png,.zip,.csv,.html,.htm',
  typeError:
    'File not supported. You can upload PDF, DOCX, XLSX, JPEG, HEIC, PNG, ZIP, CSV, or HTML/HTM.',
  sizeError: 'File too large. Upload file up to 25 MB.',
};

export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB

export const MAX_TOTAL_ATTACHMENTS = 10;
